export default __webpack_public_path__ + "static/media/Sanathan_Stretch_Logo.fde499e6.svg";